var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-content',[_c('v-toolbar',{attrs:{"app":"","flat":"","color":"primary","dark":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.pageName))])],1)],1),_c('v-container',[_c('v-flex',[_c('image-container',{attrs:{"images":_vm.images,"imageMonths":_vm.imageMonths}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }